const client_key = state => state.client_key;
const intent_key = state => state.intent_key;
const item_charge = state => state.item_charge;
const subscription = state => state.subscription;
const success_flag = state => state.success_flag;
const free_month = state => state.free_month;
const update_cc = state => state.update_cc;
const update_cc_result = state => state.update_cc_result;
const auto_sync_subscription = state => state.auto_sync_subscription;
const pending_auto_sync = state => state.pending_auto_sync;
const read_agreement = state => state.read_agreement;
const subscription_info = state => state.subscription_info;
const receipt_source = state => state.receipt_source;

export {
    client_key,
    intent_key,
    item_charge,
    subscription,
    success_flag,
    free_month,
    update_cc,
    update_cc_result,
    auto_sync_subscription,
    pending_auto_sync,
    read_agreement,
    subscription_info,
    receipt_source,
}
